module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/shovel-4ddef381dc920bcd8f24faf9565e6c2e.svg";